import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=35a9f19c&scoped=true&"
import script from "./main-footer.vue?vue&type=script&lang=js&"
export * from "./main-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9f19c",
  null
  
)

export default component.exports